import { LoginComponent } from '../app/pages/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser'
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from './pages/modal/modal.component';
import { AddNewSubOtpModalComponent } from './pages/add-new-sub-otp-modal/add-new-sub-otp-modal.component';
import { CancelSubDialogComponent } from './pages/cancel-sub-dialog/cancel-sub-dialog.component';
import { CancelRepDialogComponent } from './pages/cancel-rep-dialog/cancel-rep-dialog.component';
import { AddNewAdminDialogComponent } from './pages/add-new-admin-dialog/add-new-admin-dialog.component';
import { FileUploadModule } from 'ng2-file-upload';
import { EditBookDeliveryComponent } from './pages/edit-book-delivery/edit-book-delivery.component';
import { EditBookStockComponent } from './pages/edit-book-stock/edit-book-stock.component';
import { EditBookComponent } from './pages/edit-book/edit-book.component';
import { ViewBookComponent } from './pages/view-book/view-book.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { SubscriptioninvoiceComponent } from './pages/subscriptioninvoice/subscriptioninvoice.component';
import { UpdateAdvtDetailsComponent } from './pages/update-advt-details/update-advt-details.component';
import { UpdatePlublishDatesComponent } from './pages/update-plublish-dates/update-plublish-dates.component';
import { AdvertisementInvoiceComponent } from './pages/advertisement-invoice/advertisement-invoice.component';
import { CreditvoucherDialogComponent } from './pages/creditvoucher-dialog/creditvoucher-dialog.component';
import { ReciptComponent } from './pages/recipt/recipt.component';
import { BookstoresendmessageComponent } from './pages/bookstoresendmessage/bookstoresendmessage.component';
import { BookstorereceiptComponent } from './pages/bookstorereceipt/bookstorereceipt.component';
import { UpdateOfficeRepresentativeComponent } from './pages/update-office-representative/update-office-representative.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UpdateSubtypeComponent } from './pages/update-subtype/update-subtype.component';
import { SubscribersreceiptComponent } from './pages/subscribersreceipt/subscribersreceipt.component';
import { AddBookPerPriceComponent } from './pages/add-book-per-price/add-book-per-price.component';
import { UpdateBookPerPriceComponent } from './pages/update-book-per-price/update-book-per-price.component';
import { BookCrdtnoteRcptComponent } from './pages/book-crdtnote-rcpt/book-crdtnote-rcpt.component';
import { ShowBookInvoiceComponent } from './pages/show-book-invoice/show-book-invoice.component';
import { ShowBookCrdtNoteRcptComponent } from './pages/show-book-crdt-note-rcpt/show-book-crdt-note-rcpt.component';
import { ShowBookSellerOutStandingReportComponent } from './pages/show-book-seller-out-standing-report/show-book-seller-out-standing-report.component';
import { AuthorAddressComponent } from './pages/author-address/author-address.component';
import { BookSellerAddressComponent } from './pages/book-seller-address/book-seller-address.component';
import { ShowBookSellerOutstandingDataComponent } from './pages/show-book-seller-outstanding-data/show-book-seller-outstanding-data.component';
import { DatewiseRepresentativewiseComponent } from './pages/datewise-representativewise/datewise-representativewise.component';
import { ReturnReceiptDialogComponent } from './pages/return-receipt-dialog/return-receipt-dialog.component';
import { NgxPrintModule } from 'ngx-print';
import { DatewiseComponent } from './pages/datewise/datewise.component';
import { MonthwiseComponent } from './pages/subscription/monthwise/monthwise.component';
import { OfficeRepresentativewiseComponent } from './pages/office-representativewise/office-representativewise.component';
import { DistrictwiseTalukawiseComponent } from './pages/districtwise-talukawise/districtwise-talukawise.component';
import { RemainingRenewableListOfAddressComponent } from './pages/remaining-renewable-list-of-address/remaining-renewable-list-of-address.component';
import { RepwiseAddressListComponent } from './pages/repwise-address-list/repwise-address-list.component';
import { SubscriptionRenewalRemainderletterComponent } from './pages/subscription-renewal-remainderletter/subscription-renewal-remainderletter.component';
import { RepresentativewiseAddressComponent } from './pages/representativewise-address/representativewise-address.component';
import { SubscribersAddressComponent } from './pages/subscribers-address/subscribers-address.component';
import { ShowDistributionComponent } from './pages/show-distribution/show-distribution.component';
import { MatIconModule } from '@angular/material/icon';
import { UpdateAdvtSizesComponent } from './pages/update-advt-sizes/update-advt-sizes.component';
import { AddressLabelsComponent } from './pages/address-labels/address-labels.component';
import { AddressLabelsMobileNoComponent } from './pages/address-labels-mobile-no/address-labels-mobile-no.component';
import { PincodewiseStatementComponent } from './pages/pincodewise-statement/pincodewise-statement.component';
import { DistrictwiseStatementComponent } from './pages/districtwise-statement/districtwise-statement.component';
import { HandDeliveryComponent } from './pages/hand-delivery/hand-delivery.component';
import { PostStatementComponent } from './pages/post-statement/post-statement.component';
import { PostStatementTapalComponent } from './pages/post-statement-tapal/post-statement-tapal.component';
import { PrintGSTReportComponent } from './pages/print-gstreport/print-gstreport.component';
import { ShowSubscriptionNodaniReceiptComponent } from './pages/show-subscription-nodani-receipt/show-subscription-nodani-receipt.component';
import { LabelsOfHandDeliveryComponent } from './pages/labels-of-hand-delivery/labels-of-hand-delivery.component';
import { PrintOrderStatementComponent } from './pages/subscription/print-order-statement/print-order-statement.component';
import { PrintJavakComponent } from './pages/subscription/print-javak/print-javak.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { UpdateStateMasterComponent } from './pages/update-state-master/update-state-master.component';
import { UpdateDistrictMasterComponent } from './pages/update-district-master/update-district-master.component';
import { UpdateTalukaMasterComponent } from './pages/update-taluka-master/update-taluka-master.component';
import { RegistrationReportComponent } from './pages/registration-report/registration-report.component';
import { PrasiddhipatrakComponent } from './pages/prasiddhipatrak/prasiddhipatrak.component';
import { PrasiddhipatrakbrowseComponent } from './pages/prasiddhipatrakbrowse/prasiddhipatrakbrowse.component';
import { HanddeliverylabelslistComponent } from './pages/handdeliverylabelslist/handdeliverylabelslist.component';
import { CreditDebitLedgerReportComponent } from './pages/credit-debit-ledger-report/credit-debit-ledger-report.component';
import { HandDeliveryIndetailReportComponent } from './pages/hand-delivery-indetail-report/hand-delivery-indetail-report.component';
import { OtherStatePincodewiseStatementComponent } from './pages/other-state-pincodewise-statement/other-state-pincodewise-statement.component';
import { ShowSubscriberReceiptLedgerPrintComponent } from './pages/show-subscriber-receipt-ledger-print/show-subscriber-receipt-ledger-print.component';
import { ContractBriefReportComponent } from './pages/contract-brief-report/contract-brief-report.component';
import { AdvtBillComponent } from './pages/advt-bill/advt-bill.component';
import { ViewAdvtBillComponent } from './pages/view-advt-bill/view-advt-bill.component';
import { AdvtInvoiceRegisterComponent } from './pages/advt-invoice-register/advt-invoice-register.component';
import { AddAdvtIssuePerPriceComponent } from './pages/add-advt-issue-per-price/add-advt-issue-per-price.component';
import { UpdateAdvtIssuePerPriceComponent } from './pages/update-advt-issue-per-price/update-advt-issue-per-price.component';
import { AdvtInvoicePaymentReceiptComponent } from './pages/advt-invoice-payment-receipt/advt-invoice-payment-receipt.component';
import { ViewPrintOrderComponent } from './pages/view-print-order/view-print-order.component';
import { UpdatePrintOrderComponent } from './pages/update-print-order/update-print-order.component';
import { DistrictwiseSubscriptionReportComponent } from './pages/subscription/districtwise-subscription-report/districtwise-subscription-report.component';
import { DistrictwiseVarganidarSubscriptionReportComponent } from './pages/subscription/districtwise-varganidar-subscription-report/districtwise-varganidar-subscription-report.component';
import { PrantwiseVarganidarReportComponent } from './pages/subscription/prantwise-varganidar-report/prantwise-varganidar-report.component';
import { UpdatePrantComponent } from './pages/admin/update-prant/update-prant.component';
import { MatSelectModule } from '@angular/material/select';
import { DatewiseVarganidarRojmelReportComponent } from './pages/subscription/datewise-varganidar-rojmel-report/datewise-varganidar-rojmel-report.component';
import { RenewRemainingDataComponent } from './pages/subscription/renew-remaining-data/renew-remaining-data.component';
import { DatePipe } from '@angular/common';
import { OpenselectmodalComponent } from './openselectmodal/openselectmodal.component';
import { CommmodalComponent } from './commmodal/commmodal.component';
import { CrreceiptComponent } from './crreceipt/crreceipt.component';
import { AddmodalComponent } from './addmodal/addmodal.component';
import { AlladdComponent } from './alladd/alladd.component';
import { MatChipsModule } from '@angular/material/chips';
import { TworeceiptComponent } from './tworeceipt/tworeceipt.component';
import { ToastrModule } from 'ngx-toastr';
import { RepbusinessreportComponent } from './repbusinessreport/repbusinessreport.component';
import { PrintchallanComponent } from './printchallan/printchallan.component';
import { OlddataupdateComponent } from './olddataupdate/olddataupdate.component';
import { ExpenseledgerComponent } from './expenseledger/expenseledger.component';
import { AgGridAngular } from 'ag-grid-angular';
import { RepledgerComponent } from './repledger/repledger.component';
import { CreditorsreportComponent } from './creditorsreport/creditorsreport.component';
import { StampreceiptComponent } from './stampreceipt/stampreceipt.component';
import { UpdatejournalvoucherComponent } from './updatejournalvoucher/updatejournalvoucher.component';
import { SubscriberdetailsbriefComponent } from './subscriberdetailsbrief/subscriberdetailsbrief.component';
import { StatewisestatementComponent } from './statewisestatement/statewisestatement.component';
import { ActiveinactivebusinessreportComponent } from './activeinactivebusinessreport/activeinactivebusinessreport.component';
import { StatewisebusinessreportComponent } from './statewisebusinessreport/statewisebusinessreport.component';
import { CountrywisebusinessreportComponent } from './countrywisebusinessreport/countrywisebusinessreport.component';
import { DistrictwisebusinessComponent } from './districtwisebusiness/districtwisebusiness.component';
import { PrantwisebusinessComponent } from './prantwisebusiness/prantwisebusiness.component';
import { TypewisebusinessreportComponent } from './typewisebusinessreport/typewisebusinessreport.component';
import { AlladdlistComponent } from './alladdlist/alladdlist.component';
import { JournaledgerlvoucherComponent } from './journaledgerlvoucher/journaledgerlvoucher.component';
import { ThreeStampReceiptComponent } from './pages/three-stamp-receipt/three-stamp-receipt.component';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { AuthLayoutModule } from './layouts/auth-layout/auth-layout.module';
import { SecurityComponent } from './components/security/security.component';
import { SubexpcvdvreportComponent } from './subexpcvdvreport/subexpcvdvreport.component';
import { BooktworeciptComponent } from './booktworecipt/booktworecipt.component';
import { CommonModule } from '@angular/common';
import { DistrictRepresentativeBussinessComponent } from './district-representative-bussiness/district-representative-bussiness.component';
import { TrialBalanceComponent } from './trial-balance/trial-balance.component';
import { ExpenditureIncomeReportComponent } from './expenditure-income-report/expenditure-income-report.component';
import { IssueSellerRegistrationReportComponentComponent } from './pages/issue-seller-registration-report-component/issue-seller-registration-report-component.component';
import { BookSellerLedgerBriefReportComponentComponent } from './book-seller-ledger-brief-report-component/book-seller-ledger-brief-report-component.component';
import { IssueSellerInvoiceBillComponent } from './pages/issue-seller-invoice-bill/issue-seller-invoice-bill.component';
import { ViewIssueSellerInvoiceComponent } from './view-issue-seller-invoice/view-issue-seller-invoice.component';
import { ShowBookOrderComponent } from './show-book-order/show-book-order.component';
import { PostingLabelBriefComponent } from './pages/subscription/posting-label-brief/posting-label-brief.component';
import { TrialBalanceNewComponent } from './trial-balance-new/trial-balance-new.component';
import { AddIssueSellerPerPriceComponent } from './add-issue-seller-per-price/add-issue-seller-per-price.component';
import { UpdateIssueSellerPerPriceComponentComponent } from './update-issue-seller-per-price-component/update-issue-seller-per-price-component.component';
import { IssueSellerInvoicePaymentReceiptComponent } from './issue-seller-invoice-payment-receipt/issue-seller-invoice-payment-receipt.component';
import { AddBookCreditPriceComponent } from './add-book-credit-price/add-book-credit-price.component';
import { PrasiddhiPatrakAddressComponent } from './prasiddhi-patrak-address/prasiddhi-patrak-address.component';
import { BookCreditNoteRegisterComponent } from './book-credit-note-register/book-credit-note-register.component';
import { AddModalListComponent } from './add-modal-list/add-modal-list.component';
import { WpParamMappingDialogComponent } from './pages/wp-param-mapping-dialog/wp-param-mapping-dialog.component';
import { IssueContractReportComponent } from './issue-contract-report/issue-contract-report.component';
import { AdvertisementAddressComponent } from './advertisement-address/advertisement-address.component';
import { PrasiddhiPatrakListComponent } from './prasiddhi-patrak-list/prasiddhi-patrak-list.component';
import { IssueCotractBriefReportComponent } from './issue-cotract-brief-report/issue-cotract-brief-report.component';
import { IssueSellerInvoiceRegisterComponent } from './issue-seller-invoice-register/issue-seller-invoice-register.component';
import { IssueCreditVoucherPaymtRecieptBriflyReportComponent } from './issue-credit-voucher-paymt-reciept-brifly-report/issue-credit-voucher-paymt-reciept-brifly-report.component';
import { IssueCreditVoucheofficerIndetailReportComponent } from './issue-credit-voucheofficer-indetail-report/issue-credit-voucheofficer-indetail-report.component';
import { IssueCreditVoucherVeryBriflyOfficerReportComponent } from './issue-credit-voucher-very-brifly-officer-report/issue-credit-voucher-very-brifly-officer-report.component';
import { IssuecreditvoucherbrieflyofficerreportComponent } from './issuecreditvoucherbrieflyofficerreport/issuecreditvoucherbrieflyofficerreport.component';
import { IssueSellerIndetailCreditVoucherReportComponent } from './issue-seller-indetail-credit-voucher-report/issue-seller-indetail-credit-voucher-report.component';
import { AddBookPerCommisionPriceComponent } from './add-book-per-commision-price/add-book-per-commision-price.component';
import { BookCommRcptComponent } from './book-comm-rcpt/book-comm-rcpt.component';
import { BookCommissionNoteRegisterComponent } from './book-commission-note-register/book-commission-note-register.component';
import { BarcodeDialogComponent } from './barcode-dialog/barcode-dialog.component';
import { CreaditReceiptComponentComponent } from './creadit-receipt-component/creadit-receipt-component.component';
import { DepositSlipReportComponent } from './deposit-slip-report/deposit-slip-report.component';
import { AddressLableMobileNoEnglishComponent } from './pages/address-lable-mobile-no-english/address-lable-mobile-no-english.component';
import { NumberWithoutCommasPipeComponent } from './number-without-commas-pipe/number-without-commas-pipe.component';
import { OpenIssueSellerCreditNoteComponent } from './open-issue-seller-credit-note/open-issue-seller-credit-note.component';
import { AdvertisementAddressListComponent } from './advertisement-address-list/advertisement-address-list.component';
import { OutstandingReportComponent } from './outstanding-report/outstanding-report.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { IssueSellerPersonalLedgerComponent } from './issue-seller-personal-ledger/issue-seller-personal-ledger.component';
import { IssueSellerBrieflyPersonalLedgerComponentComponent } from './issue-seller-briefly-personal-ledger-component/issue-seller-briefly-personal-ledger-component.component';
import { IssueSellerAddressGSTReportComponent } from './issue-seller-address-gstreport/issue-seller-address-gstreport.component';
import { IssueSellerContractBriefReportComponent } from './issue-seller-contract-brief-report/issue-seller-contract-brief-report.component';
import { IssueSellerOutstandibgIndetailReportsComponent } from './issue-seller-outstandibg-indetail-reports/issue-seller-outstandibg-indetail-reports.component';
import { SaveAssignRepresentativeDistributerDailogComponent } from './pages/save-assign-representative-distributer-dailog/save-assign-representative-distributer-dailog.component';
import { AdvtOutstandingReportComponent } from './pages/advt-outstanding-report/advt-outstanding-report.component';
import { DistrictwiseOfficeRepresentativeBussinessComponent } from './pages/subscription/districtwise-office-representative-bussiness/districtwise-office-representative-bussiness.component';
import { IssueSellerAddressComponent } from './issue-seller-address/issue-seller-address.component';
import { DebitVoucherBillComponent } from './debit-voucher-bill/debit-voucher-bill.component';
import { VeryBriflyDatewiseComponent } from './very-brifly-datewise/very-brifly-datewise.component';
import { IssueBriflyDatewiseComponent } from './issue-brifly-datewise/issue-brifly-datewise.component';
import { IndetailDatewiseRptComponent } from './indetail-datewise-rpt/indetail-datewise-rpt.component';
import { IssueVeryBrifRepresentativeComponent } from './issue-very-brif-representative/issue-very-brif-representative.component';
import { BrifRepresentativeReportComponent } from './brif-representative-report/brif-representative-report.component';
import { VeryBrifOffRepresantativeComponent } from './very-brif-off-represantative/very-brif-off-represantative.component';
import { IssueSellerCreditNoteRegisterInDetailComponent } from './issue-seller-credit-note-register-in-detail/issue-seller-credit-note-register-in-detail.component';
import { IssueSellerCreditNoteBrieflyComponent } from './issue-seller-credit-note-briefly/issue-seller-credit-note-briefly.component';
import { IssueSellerCreditNoteMonthwiseComponent } from './issue-seller-credit-note-monthwise/issue-seller-credit-note-monthwise.component';
import { IssueSellerCreditNoteInDetailOfficerComponent } from './issue-seller-credit-note-in-detail-officer/issue-seller-credit-note-in-detail-officer.component';
import { IssueSellerCreditNoteVeryBrieflyCreditNoteComponent } from './issue-seller-credit-note-very-briefly-credit-note/issue-seller-credit-note-very-briefly-credit-note.component';
import { IssueSellerBrieflyOfficeCreditComponent } from './issue-seller-briefly-office-credit/issue-seller-briefly-office-credit.component';
import { PaymentReceiptRegisterComponent } from './payment-receipt-register/payment-receipt-register.component';
import { PaymentRegisterMonthwiseComponent } from './payment-register-monthwise/payment-register-monthwise.component';
import { PaymnetReceiptIndetailOfficerComponent } from './paymnet-receipt-indetail-officer/paymnet-receipt-indetail-officer.component';
import { PaymnetReceieptVeryBreiflyOfficerComponent } from './paymnet-receiept-very-breifly-officer/paymnet-receiept-very-breifly-officer.component';
import { PaymentReceiptBrieflyOfficerComponent } from './payment-receipt-briefly-officer/payment-receipt-briefly-officer.component';
import { CreditNoteRegisterIndetailComponent } from './credit-note-register-indetail/credit-note-register-indetail.component';
import { CreditNoteBrieflyRegisterComponent } from './credit-note-briefly-register/credit-note-briefly-register.component';
import { CreditNoteMonthwiseRegisterComponent } from './credit-note-monthwise-register/credit-note-monthwise-register.component';
import { CreditNoteInDetailCreditOfficerComponent } from './credit-note-in-detail-credit-officer/credit-note-in-detail-credit-officer.component';
import { CreditNoteVeryBrieflyCreditNoteComponent } from './credit-note-very-briefly-credit-note/credit-note-very-briefly-credit-note.component';
import { CreditNoteBrieflyOfficerCreditComponent } from './credit-note-briefly-officer-credit/credit-note-briefly-officer-credit.component';
import { RepresentativeAddressListComponent } from './representative-address-list/representative-address-list.component';
import { AdvtRepresentativeAddressListComponent } from './advt-representative-address-list/advt-representative-address-list.component';
import { PaymentReceiptIndetailReportComponent } from './payment-receipt-indetail-report/payment-receipt-indetail-report.component';
import { GSTReportComponent } from './gstreport/gstreport.component';
import { IssueSellerHanddeliverylabelslistComponent } from './issue-seller-handdeliverylabelslist/issue-seller-handdeliverylabelslist.component';
import { IssueSellerOtherStatePincodewiseStatementComponent } from './issue-seller-other-state-pincodewise-statement/issue-seller-other-state-pincodewise-statement.component';
import { IssueSellerPincodewiseStatementComponent } from './issue-seller-pincodewise-statement/issue-seller-pincodewise-statement.component';
import { IssueSellerHandDeliveryComponentComponent } from './issue-seller-hand-delivery-component/issue-seller-hand-delivery-component.component';
import { IssueSellerPostStatementComponentComponent } from './issue-seller-post-statement-component/issue-seller-post-statement-component.component';
import { IssueSellerUpdatePrintOrderComponentComponent } from './issue-seller-update-print-order-component/issue-seller-update-print-order-component.component';
import { IssueSellerPrintJavakComponentComponent } from './issue-seller-print-javak-component/issue-seller-print-javak-component.component';
import { IssueSellerDistrictwiseSubscriptionReportComponent } from './issue-seller-districtwise-subscription-report/issue-seller-districtwise-subscription-report.component';
import { IssueSellerDistrictwiseVarganidarSubscriptionReportComponent } from './issue-seller-districtwise-varganidar-subscription-report/issue-seller-districtwise-varganidar-subscription-report.component';
import { IssueSellerAddressLabelsComponent } from './issue-seller-address-labels/issue-seller-address-labels.component';
import { IssueSellerAddressLabelsMobileNoComponent } from './issue-seller-address-labels-mobile-no/issue-seller-address-labels-mobile-no.component';
import { IssueSellerPostingLabelBriefComponentComponent } from './issue-seller-posting-label-brief-component/issue-seller-posting-label-brief-component.component';
import { IssueSellerPostingLabelBriefComponent } from './issue-seller-posting-label-brief/issue-seller-posting-label-brief.component';
import { IssueSellerBarcodeDialogComponent } from './issue-seller-barcode-dialog/issue-seller-barcode-dialog.component';
import { IssueSellerLabelsOfHandDeliveryComponent } from './issue-seller-labels-of-hand-delivery/issue-seller-labels-of-hand-delivery.component';
import { IssueSellerPrintOrderStatementComponentComponent } from './issue-seller-print-order-statement-component/issue-seller-print-order-statement-component.component';
import { IssueSellerViewPrintOrderComponentComponent } from './issue-seller-view-print-order-component/issue-seller-view-print-order-component.component';
import { IssueSellerPrantwiseVarganidarReportComponent } from './issue-seller-prantwise-varganidar-report/issue-seller-prantwise-varganidar-report.component';
import { IssueSellerDistrictwiseStatementComponentComponent } from './issue-seller-districtwise-statement-component/issue-seller-districtwise-statement-component.component';
import { IssueSellerStatewisestatementComponent } from './issue-seller-statewisestatement/issue-seller-statewisestatement.component';
import { BookReceiptReportComponent } from './book-receipt-report/book-receipt-report.component';
import { DistrictandtalukawiseRepresentativeComponent } from './districtandtalukawise-representative/districtandtalukawise-representative.component';
import { DistrictandtalukawiseOfficeRepresentativeComponent } from './districtandtalukawise-office-representative/districtandtalukawise-office-representative.component';
import { RecoBriefReportComponent } from './reco-brief-report/reco-brief-report.component';
import { BankRecoInBriefReportComponent } from './bank-reco-in-brief-report/bank-reco-in-brief-report.component';
import { AccSubscriptionMonthwiseReportComponent } from './acc-subscription-monthwise-report/acc-subscription-monthwise-report.component';
import { DatewiseBrieflyComponent } from './pages/datewise-briefly/datewise-briefly.component';
import { PrintOrderByfurgationNewComponent } from './pages/print-order-byfurgation-new/print-order-byfurgation-new.component';
import { PrintOrderByfurgationReportComponent } from './pages/print-order-byfurgation-report/print-order-byfurgation-report.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { OfficeRepresentativeDistrictComponent } from './office-representative-district/office-representative-district.component';
import { RepresentativewiseDistrictlyComponent } from './pages/representativewise-districtly/representativewise-districtly.component';
import { OfficeRepresentativeDistrictWiseComponent } from './office-representative-district-wise/office-representative-district-wise.component';
import { TwoReceiptIssuesaleComponentComponent } from './two-receipt-issuesale-component/two-receipt-issuesale-component.component';
import { AddAdvtRepPerPriceComponent } from './add-advt-rep-per-price/add-advt-rep-per-price.component';
import { RegistrationRepVeryBrieflyComponent } from './registration-rep-very-briefly/registration-rep-very-briefly.component';
import { UnpaidOutstandingInDetailComponent } from './unpaid-outstanding-in-detail/unpaid-outstanding-in-detail.component';
import { RegistrationBrieflyRepresentativeComponent } from './registration-briefly-representative/registration-briefly-representative.component';
import { AdvtInvoiceIndetailReportComponent } from './advt-invoice-indetail-report/advt-invoice-indetail-report.component';
import { OutstandingBrieflyReportComponent } from './outstanding-briefly-report/outstanding-briefly-report.component';
import { BookReceiptVeryBrieflyOfficerComponent } from './book-receipt-very-briefly-officer/book-receipt-very-briefly-officer.component';
import { BookReceiptIndetailOfficerComponent } from './book-receipt-indetail-officer/book-receipt-indetail-officer.component';
import { RegistrationDatewiseBrieflyComponent } from './registration-datewise-briefly/registration-datewise-briefly.component';
import { RegistrationDatewiseDetailsComponent } from './registration-datewise-details/registration-datewise-details.component';
// import { RegistrationDatewiseVbrieflyComponent } from './registration-datewise-vbriefly/registration-datewise-vbriefly.component';
import { RegistrationOfficeRepresentativeBrieflyComponent } from './registration-office-representative-briefly/registration-office-representative-briefly.component';
import { RegistrationOfficeRepresentativeDetailComponent } from './registration-office-representative-detail/registration-office-representative-detail.component';
import { UnpaidOutstandingBrieflyReportComponent } from './unpaid-outstanding-briefly-report/unpaid-outstanding-briefly-report.component';
import { RegistrationRepresentiveDetailComponent } from './registration-representive-detail/registration-representive-detail.component';
import { RegistrationDatewiseVbrieflyComponent } from './registration-datewise-vbriefly/registration-datewise-vbriefly.component';
import { RegistrationOfficeRepresentativeVbrieflyComponent } from './registration-office-representative-vbriefly/registration-office-representative-vbriefly.component';
import { RegistrationBrieflyComponent } from './registration-briefly/registration-briefly.component';
import { RegistrationIndetailsComponent } from './registration-indetails/registration-indetails.component';
import { UnpaidOutstandingVbrieflyComponent } from './unpaid-outstanding-vbriefly/unpaid-outstanding-vbriefly.component';
import { OutstandingGstRegistrationReportComponent } from './outstanding-gst-registration-report/outstanding-gst-registration-report.component';
import { IssueSellerCreditNoteRegisterComponentComponent } from './issue-seller-credit-note-register-component/issue-seller-credit-note-register-component.component';
import { PersonalLedgerInDetailComponent } from './personal-ledger-in-detail/personal-ledger-in-detail.component';
import { YearwiseAppComponent } from './yearwise-app/yearwise-app.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PersonalLedgerInDetail1Component } from './personal-ledger-in-detail1/personal-ledger-in-detail1.component';
import { IssueSalePrintChallanComponent } from './issue-sale-print-challan/issue-sale-print-challan.component';
import { IssuesellerdispatchreportlistComponent } from './issuesellerdispatchreportlist/issuesellerdispatchreportlist.component';
import { IssueSellerpostingOfficerepreportComponent } from './issue-sellerposting-officerepreport/issue-sellerposting-officerepreport.component';
import { ComModalPrintComponent } from './com-modal-print/com-modal-print.component';
import { ExpenseLedgerReportComponent } from './expense-ledger-report/expense-ledger-report.component';
import { CompletedCommissionReportComponent } from './completed-commission-report/completed-commission-report.component';
import { PendingCommReportComponent } from './pending-comm-report/pending-comm-report.component';
import { BriefAddressLabelComponent } from './pages/subscription/brief-address-label/brief-address-label.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { UserPermissionsComponent } from './user-permissions/user-permissions.component';
import { AdminRegistrationComponent } from './admin-registration/admin-registration.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AdvtInvoiceMonthwiseRegisterComponent } from './advt-invoice-monthwise-register/advt-invoice-monthwise-register.component';
import { RepresentativewiseTalukaComponent } from './pages/representativewise-taluka/representativewise-taluka.component';
import { AdvtInvoiceRegisterIndetailOfficerComponent } from './advt-invoice-register-indetail-officer/advt-invoice-register-indetail-officer.component';
import { SubscriberRecLedgerAddressLabelComponent } from './pages/subscriber-rec-ledger-address-label/subscriber-rec-ledger-address-label.component';
import { PackageReportComponent } from './package-report/package-report.component';
import { AdvtInvoiceRegisterOfficeBrieflyComponent } from './advt-invoice-register-office-briefly/advt-invoice-register-office-briefly.component';
import { AdvtInvoiceRegisterOfficeVBrieflyComponent } from './advt-invoice-register-office-vbriefly/advt-invoice-register-office-vbriefly.component';
import { ShowOrderEntryBookSellerComponent } from './show-order-entry-book-seller/show-order-entry-book-seller.component';
import { OpeninvoiceprintComponent } from './openinvoiceprint/openinvoiceprint.component';
import { AdvtoutstandingAllbrieflyComponent } from './advtoutstanding-allbriefly/advtoutstanding-allbriefly.component';
import { AdvtInvoiceVeryBrieflyComponent } from './advt-invoice-very-briefly/advt-invoice-very-briefly.component';
import { SharedService } from './services/shared.service';
import { AddBookPerPriceComponent1Component } from './add-book-per-price-component1/add-book-per-price-component1.component';
import { Bookstoresendmessage1Component } from './bookstoresendmessage1/bookstoresendmessage1.component';
import { AddBookCreditPrice1Component } from './add-book-credit-price1/add-book-credit-price1.component';
import { BooksellerbillingregisterreportComponent } from './booksellerbillingregisterreport/booksellerbillingregisterreport.component';
import { AdvtStampRegisterReportComponentComponent } from './advt-stamp-register-report-component/advt-stamp-register-report-component.component';
import { AdvtCreditPrintComponent } from './advt-credit-print/advt-credit-print.component';
import { PrasiddhiPatrakRepresentaiveListComponent } from './prasiddhi-patrak-representaive-list/prasiddhi-patrak-representaive-list.component';
import { CreditOutstandingIndetailsComponent } from './credit-outstanding-indetails/credit-outstanding-indetails.component';
import { SendReminderLetterAdvtComponent } from './send-reminder-letter-advt/send-reminder-letter-advt.component';
import { AllCommReportComponent } from './all-comm-report/all-comm-report.component';
import { AllRepBookCommissionComponent } from './all-rep-book-commission/all-rep-book-commission.component';
import { RepCommissionPaidComponent } from './rep-commission-paid/rep-commission-paid.component';
import { RepUnpaidCommissionComponent } from './rep-unpaid-commission/rep-unpaid-commission.component';
import { OfficeRepBrieflyComponent } from './office-rep-briefly/office-rep-briefly.component';
import { BookReceiptIndetailallComponent } from './book-receipt-indetailall/book-receipt-indetailall.component';
import { BookReceiptAllBrieflyComponent } from './book-receipt-all-briefly/book-receipt-all-briefly.component';
import { OfficeRepInDetailsComponent } from './office-rep-in-details/office-rep-in-details.component';
import { BookReceiptBrieflyOfficerComponent } from './book-receipt-briefly-officer/book-receipt-briefly-officer.component';
import { BookReceiptMonthwiseComponent } from './book-receipt-monthwise/book-receipt-monthwise.component';
import { BookCreditNoteReportComponent } from './book-credit-note-report/book-credit-note-report.component';
import { BookCreditNoteReportBrieflyComponent } from './book-credit-note-report-briefly/book-credit-note-report-briefly.component';
import { BookCreditNoteReportMonthwiseComponent } from './book-credit-note-report-monthwise/book-credit-note-report-monthwise.component';
import { BookCreditNoteReportInDetailOfficerComponent } from './book-credit-note-report-in-detail-officer/book-credit-note-report-in-detail-officer.component';
import { BookCreditNoteReportVeryBrieflyOfficerComponent } from './book-credit-note-report-very-briefly-officer/book-credit-note-report-very-briefly-officer.component';
import { BookCreditNoteReportBrieflyOfficerComponent } from './book-credit-note-report-briefly-officer/book-credit-note-report-briefly-officer.component';
import { BookRegistrationLedgerReportComponent } from './book-registration-ledger-report/book-registration-ledger-report.component';
import { BookRegistrationLedgerReportBrieflyComponent } from './book-registration-ledger-report-briefly/book-registration-ledger-report-briefly.component';
import { BookRegistrationLedgerReportVBrieflyComponent } from './book-registration-ledger-report-vbriefly/book-registration-ledger-report-vbriefly.component';
import { BookRegistrationLedgerReportInDetailOfficerComponent } from './book-registration-ledger-report-in-detail-officer/book-registration-ledger-report-in-detail-officer.component';
import { BookRegistrationLedgerReportVeryBrieflyOfficerComponent } from './book-registration-ledger-report-very-briefly-officer/book-registration-ledger-report-very-briefly-officer.component';
import { BookRegistrationLedgerReportBrieflyOfficerComponent } from './book-registration-ledger-report-briefly-officer/book-registration-ledger-report-briefly-officer.component';
import { SendReminderLetterRepComponent } from './send-reminder-letter-rep/send-reminder-letter-rep.component';
import { AddressAdvtLabelsComponent } from './address-advt-labels/address-advt-labels.component';
import { TalukawiseSubscriberDetailsReportComponent } from './pages/subscription/talukawise-subscriber-details-report/talukawise-subscriber-details-report.component';
import { SubscriberListComponent } from './subscriber-list/subscriber-list.component';
import { BusinessReportIndetailComponent } from './business-report-indetail/business-report-indetail.component';
import { BusinessReportBrieflyComponent } from './business-report-briefly/business-report-briefly.component';
import { BusinessReportVeryBrieflyComponent } from './business-report-very-briefly/business-report-very-briefly.component';
import { IssueWiseReportAdvtBusinessComponent } from './issue-wise-report-advt-business/issue-wise-report-advt-business.component';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet/balance-sheet.component';
import { IssueWiseReportAdvtDetailBusinessComponent } from './issue-wise-report-advt-detail-business/issue-wise-report-advt-detail-business.component';
import { SendReminderLetterBookComponent } from './send-reminder-letter-book/send-reminder-letter-book.component';
import { SendReminderLetterRepBookComponent } from './send-reminder-letter-rep-book/send-reminder-letter-rep-book.component';
import { CreditVoucherIssuesComponent } from './credit-voucher-issues/credit-voucher-issues.component';
import { DebitVoucherIssuesComponent } from './debit-voucher-issues/debit-voucher-issues.component';
import { RepresentativewiseSadhyasthitiReportComponent } from './pages/subscription/representativewise-sadhyasthiti-report/representativewise-sadhyasthiti-report.component';
import { DistrictRepresentativewiseSadhyasthitiReportComponent } from './pages/subscription/district-representativewise-sadhyasthiti-report/district-representativewise-sadhyasthiti-report.component';
import { TalukaRepresentativewiseSadhyasthitiReportComponent } from './pages/subscription/taluka-representativewise-sadhyasthiti-report/taluka-representativewise-sadhyasthiti-report.component';
import { ContractIndetailReportComponent } from './contract-indetail-report/contract-indetail-report.component';
import { LekhakMasterComponent } from './lekhak_management/lekhak-master/lekhak-master.component';
import { AdvtissueYearWiseReportComponent } from './advtissue-year-wise-report/advtissue-year-wise-report.component';
import { JahiriatJamaReportComponent } from './jahiriat-jama-report/jahiriat-jama-report.component';
import { JahiratPratinidiwiseJamareportComponent } from './jahirat-pratinidiwise-jamareport/jahirat-pratinidiwise-jamareport.component';
import { LekhReportComponent } from './lekh-report/lekh-report.component';
import { YeneBakiJahiratReportComponent } from './yene-baki-jahirat-report/yene-baki-jahirat-report.component';
import { YenebakiOffwiseJahirataComponent } from './yenebaki-offwise-jahirata/yenebaki-offwise-jahirata.component';
import { ContractBrieflyReportComponent } from './contract-briefly-report/contract-briefly-report.component';
import { EditBookExpenseComponent } from './edit-book-expense/edit-book-expense.component';
import { CreditorsIssuesComponent } from './creditors-issues/creditors-issues.component';
import { BusinessReportIndetailComponentComponent } from './business-report-indetail-component/business-report-indetail-component.component';
import { BusinessReportComponent } from './business-report/business-report.component';
// import { MonthwiseReportComponent } from './monthwise-report/monthwise-report.component';
import { VatnavalDistributionComponent } from './pages/vatnaval-distribution/vatnaval-distribution.component';
import { ViewVatnavalComponent } from './pages/view-vatnaval/view-vatnaval.component';
import { ReceiptpackagebookComponent } from './receiptpackagebook/receiptpackagebook.component';
import { ViewReceiptpackagebookComponent } from './viewreceiptpackagebook/viewreceiptpackagebook.component';
import { MonthwiseReportComponent } from './monthwise-report/monthwise-report.component';
import { BookwiseReportComponent } from './bookwise-report/bookwise-report.component';
import { OfficeRepMonthwiseReportComponent } from './office-rep-monthwise-report/office-rep-monthwise-report.component';
import { SubscriptionTypeDistrictwiseComponent } from './subscription-type-districtwise/subscription-type-districtwise.component';
import { BusinessReportVeryBriefly1Component } from './business-report-very-briefly1/business-report-very-briefly1.component';
import { GranthInvoiceComponent } from './granth-invoice/granth-invoice.component';
import { ShowGranthInvoiceComponent } from './show-granth-invoice/show-granth-invoice.component';
import { AllBusinessReportSubscriptionComponent } from './pages/all-business-report-subscription/all-business-report-subscription.component';
import { AllTotalBusinessReportSubscriptionComponent } from './pages/all-total-business-report-subscription/all-total-business-report-subscription.component';
import { PrantwiseAllTotalBusinessReportComponent } from './pages/prantwise-all-total-business-report/prantwise-all-total-business-report.component';
import { PrantwiseAllTotalTalukawiseBusinessReportComponent } from './pages/prantwise-all-total-talukawise-business-report/prantwise-all-total-talukawise-business-report.component';
import { MonthWiseBusinessReportComponent } from './month-wise-business-report/month-wise-business-report.component';
import { BookSellerAddressLabelsComponent } from './pages/book-seller-address-labels/book-seller-address-labels.component';
import { ExpenseOpeningBalanceReportComponent } from './expense-opening-balance-report/expense-opening-balance-report.component';
import { BookSellerPostingLabelBriefComponent } from './book-seller-posting-label-brief/book-seller-posting-label-brief.component';
import { BooksellerwithpratiComponent } from './booksellerwithprati/booksellerwithprati.component';
import { BooksellerwithoutpratiComponent } from './booksellerwithoutprati/booksellerwithoutprati.component';
import { BooksellerdispatchreportlistComponent } from './booksellerdispatchreportlist/booksellerdispatchreportlist.component';
import { BookSellerpostingOfficerepreportComponentComponent } from './book-sellerposting-officerepreport-component/book-sellerposting-officerepreport-component.component';
import { BarcodeDialogParcelLabelComponent } from './barcode-dialog-parcel-label/barcode-dialog-parcel-label.component';
import { ParcelLabelBarcodesEnglishComponent } from './pages/parcel-label-barcodes-english/parcel-label-barcodes-english.component';
import { BooksellerDistrictwiseStatementComponentComponent } from './bookseller-districtwise-statement-component/bookseller-districtwise-statement-component.component';
import { BookSellerStatewisestatementComponent } from './book-seller-statewisestatement/book-seller-statewisestatement.component';
import { GranthRegistaionLedgerIndetailReportComponent } from './granth-registaion-ledger-indetail-report/granth-registaion-ledger-indetail-report.component';
import { GranthRegistrationLedgerReportBriflyComponent } from './granth-registration-ledger-report-brifly/granth-registration-ledger-report-brifly.component';
import { BookSellerdispatchLabelsComponent } from './book-sellerdispatch-labels/book-sellerdispatch-labels.component';
import { BookSellerpracelLabelsComponent } from './book-sellerpracel-labels/book-sellerpracel-labels.component';
import { GranthRegistrationLedgerBriflyReportComponent } from './granth-registration-ledger-brifly-report/granth-registration-ledger-brifly-report.component';
import { GranthRegistrationLedgerIndetailOfficerReportComponent } from './granth-registration-ledger-indetail-officer-report/granth-registration-ledger-indetail-officer-report.component';
import { GranthRegistrationLedgerVeryBriflyOfficerReportComponent } from './granth-registration-ledger-very-brifly-officer-report/granth-registration-ledger-very-brifly-officer-report.component';
import { GranthRegistrationLedgerBrieflyOfficerComponent } from './granth-registration-ledger-briefly-officer/granth-registration-ledger-briefly-officer.component';
import { BusinessReportIndetailGranthComponent } from './business-report-indetail-granth/business-report-indetail-granth.component';
import { VoucherListComponent } from './pages/voucher-list/voucher-list.component';
import { BooksellerPrintJavakComponent } from './bookseller-print-javak/bookseller-print-javak.component';
import { BookSellerHandDeliveryComponent } from './book-seller-hand-delivery/book-seller-hand-delivery.component';
import { SaveAssignRepresentativeDistributerDailogComponent1Component } from './pages/save-assign-representative-distributer-dailog-component1/save-assign-representative-distributer-dailog-component1.component';
import { BookSellerPrintOrderStatementComponent } from './book-seller-print-order-statement/book-seller-print-order-statement.component';
import { BussinessReportBriflyGranthComponent } from './bussiness-report-brifly-granth/bussiness-report-brifly-granth.component';
import { AddressListAdvtComponentComponent } from './address-list-advt-component/address-list-advt-component.component';
import { BookSellerAddressLabelsComponent2Component } from './book-seller-address-labels-component2/book-seller-address-labels-component2.component';
import { BookSellerUpdatePrintOrderComponent } from './book-seller-update-print-order/book-seller-update-print-order.component';
import { BooksellerViewPrintOrderComponentComponent } from './bookseller-view-print-order-component/bookseller-view-print-order-component.component';
import { SendReminderLetterIssueComponent } from './send-reminder-letter-issue/send-reminder-letter-issue.component';
import { SendReminderLetterIssueRepComponent } from './send-reminder-letter-issue-rep/send-reminder-letter-issue-rep.component';
import { RegistrationReportGranthVeryBrieflyComponent } from './registration-report-granth-very-briefly/registration-report-granth-very-briefly.component';
import { GranthBussinessOfficeRepIndetailsComponent } from './granth-bussiness-office-rep-indetails/granth-bussiness-office-rep-indetails.component';
import { GranthBussinessOfficeRepIndetailsofficerepwiseComponent } from './granth-bussiness-office-rep-indetailsofficerepwise/granth-bussiness-office-rep-indetailsofficerepwise.component';
import { GranthSellerLedgerBriefReportIndetailComponent } from './granth-seller-ledger-brief-report-indetail/granth-seller-ledger-brief-report-indetail.component';
import { GranthOutstandingBriefComponent } from './granth-outstanding-brief/granth-outstanding-brief.component';
import { GranthOutstandingReportComponent } from './granth-outstanding-report/granth-outstanding-report.component';
import { OfficeRepBrieflyGranthComponent } from './office-rep-briefly-granth/office-rep-briefly-granth.component';
import { OfficeRepUnpaidBrieflyGranthComponent } from './office-rep-unpaid-briefly-granth/office-rep-unpaid-briefly-granth.component';
import { UnpaidGranthOutstandingBriefComponent } from './unpaid-granth-outstanding-brief/unpaid-granth-outstanding-brief.component';
import { UnpaidGranthOutstandingDetailComponent } from './unpaid-granth-outstanding-detail/unpaid-granth-outstanding-detail.component';
import { GranthSellerAddressLabelsComponent } from './granth-seller-address-labels/granth-seller-address-labels.component';
import { GrantSellerWithoutPratiComponent } from './grant-seller-without-prati/grant-seller-without-prati.component';
import { GranthSellerWithPratiComponent } from './granth-seller-with-prati/granth-seller-with-prati.component';
import { GranthSellerAddresscomponentgranthwithComponent } from './granth-seller-addresscomponentgranthwith/granth-seller-addresscomponentgranthwith.component';
import { GranthSellerDispatchReportListComponent } from './granth-seller-dispatch-report-list/granth-seller-dispatch-report-list.component';
import { GranthSellerPostingOffReportComponent } from './granth-seller-posting-off-report/granth-seller-posting-off-report.component';
import { BookSellerPrintOrderStatementgranthComponent } from './book-seller-print-order-statementgranth/book-seller-print-order-statementgranth.component';
import { GranthSellerDispatchLabelsComponent } from './granth-seller-dispatch-labels/granth-seller-dispatch-labels.component';
import { GranthSellerHandDeliveryComponent } from './granth-seller-hand-delivery/granth-seller-hand-delivery.component';
import { SaveAssignRepresentativeDistributerDailogComponentgranthComponent } from './save-assign-representative-distributer-dailog-componentgranth/save-assign-representative-distributer-dailog-componentgranth.component';
import { SellerGrantViewPrintOrderComponent } from './seller-grant-view-print-order/seller-grant-view-print-order.component';
import { SendReminderLetterGranthComponent } from './send-reminder-letter-granth/send-reminder-letter-granth.component';

// import { RegistrationOfficeRepresentativeVbrieflyComponent } from './registration-office-representative-vbriefly/registration-office-representative-vbriefly.component';
// import { RegistrationRepresentiveDetailComponent } from './registration-representive-detail/registration-representive-detail.component';



// import { ReportInDetailComponent } from './report-in-detail/reportin-detail.component';
// import { FileSaverModule } from 'ngx-filesaver';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    MatCheckboxModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatDialogModule,
    FileUploadModule,
    MatAutocompleteModule,
    NgxPrintModule,
    ScrollingModule,
    MatOptionModule,
    MatSelectModule,
    MatChipsModule,
    AdminLayoutModule,
    AuthLayoutModule,
    // FileSaverModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    BrowserModule,
    AgGridAngular,
    CommonModule,
    MatIconModule,
    NgxBarcode6Module,
    MatGridListModule,
    NgMultiSelectDropDownModule.forRoot(),
    // Ng2SearchPipeModule,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 15000, // 15 seconds
      progressBar: true,
    }),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    BusinessReportVeryBriefly1Component,
    AuthLayoutComponent,
    VeryBriflyDatewiseComponent,
    LoginComponent,
    IssueBriflyDatewiseComponent,
    IndetailDatewiseRptComponent,
    IssueVeryBrifRepresentativeComponent,
    BrifRepresentativeReportComponent,
    ModalComponent,
    VeryBrifOffRepresantativeComponent,
    AddNewSubOtpModalComponent,
    CancelSubDialogComponent,
    CancelRepDialogComponent,
    IssueSellerContractBriefReportComponent,
    AddNewAdminDialogComponent,
    WpParamMappingDialogComponent,
    OpenIssueSellerCreditNoteComponent,
    EditBookDeliveryComponent,
    EditBookStockComponent,
    EditBookComponent,
    BusinessReportIndetailComponentComponent,
    BookwiseReportComponent,
    OfficeRepMonthwiseReportComponent,
    // BusinessReportComponent

    BusinessReportComponent,
    MonthwiseReportComponent,
    MonthwiseComponent,
    // MonthwiseReportComponent,
    EditBookExpenseComponent,
    ViewBookComponent,
    AdvertisementInvoiceComponent,
    CreditvoucherDialogComponent,
    ReciptComponent,
    BookstoresendmessageComponent,
    SaveAssignRepresentativeDistributerDailogComponent1Component,
    BookSellerPrintOrderStatementComponent,
    BookSellerAddressLabelsComponent2Component,
    BooksellerViewPrintOrderComponentComponent,
    SellerGrantViewPrintOrderComponent,
    BookSellerUpdatePrintOrderComponent,
    BookSellerHandDeliveryComponent,
    BooksellerPrintJavakComponent,
    BookSellerpracelLabelsComponent,
    BookstorereceiptComponent,
    UpdateOfficeRepresentativeComponent,
    UpdateSubtypeComponent,
    SubscribersreceiptComponent,
    AddBookPerPriceComponent,
    UpdateBookPerPriceComponent,
    BookCrdtnoteRcptComponent,
    ShowBookInvoiceComponent,
    ShowBookCrdtNoteRcptComponent,
    ShowBookSellerOutStandingReportComponent,
    AuthorAddressComponent,
    BookSellerAddressComponent,
    ShowBookSellerOutstandingDataComponent,
    DatewiseRepresentativewiseComponent,
    ReturnReceiptDialogComponent,
    DatewiseComponent,
    MonthwiseComponent,
    OfficeRepresentativewiseComponent,
    DistrictwiseTalukawiseComponent,
    RemainingRenewableListOfAddressComponent,
    RepwiseAddressListComponent,
    SubscriptionRenewalRemainderletterComponent,
    RepresentativewiseAddressComponent,
    SubscribersAddressComponent,
    ShowDistributionComponent,
    AddressLabelsComponent,
    AddressLabelsMobileNoComponent,
    PincodewiseStatementComponent,
    DistrictwiseStatementComponent,
    HandDeliveryComponent,
    PostStatementComponent,
    PostStatementTapalComponent,
    PrintGSTReportComponent,
    ShowSubscriptionNodaniReceiptComponent,
    LabelsOfHandDeliveryComponent,
    PrintOrderStatementComponent,
    PrintJavakComponent,
    UpdateStateMasterComponent,
    UpdateDistrictMasterComponent,
    UpdateTalukaMasterComponent,
    RegistrationReportComponent,

    UpdateIssueSellerPerPriceComponentComponent,

    AdminRegistrationComponent,

    UserListComponent,

    PrasiddhipatrakComponent,
    PrasiddhipatrakbrowseComponent,
    HanddeliverylabelslistComponent,
    CreditDebitLedgerReportComponent,
    HandDeliveryIndetailReportComponent,
    OtherStatePincodewiseStatementComponent,
    ShowSubscriberReceiptLedgerPrintComponent,
    ContractBriefReportComponent,
    AdvtBillComponent,
    ViewAdvtBillComponent,
    AdvtInvoiceRegisterComponent,
    AddAdvtIssuePerPriceComponent,
    UpdateAdvtIssuePerPriceComponent,
    AdvtInvoicePaymentReceiptComponent,
    ViewPrintOrderComponent,
    UpdatePrintOrderComponent,
    DistrictwiseSubscriptionReportComponent,
    DistrictwiseVarganidarSubscriptionReportComponent,
    PrantwiseVarganidarReportComponent,
    UpdatePrantComponent,
    DatewiseVarganidarRojmelReportComponent,
    RenewRemainingDataComponent,
    OpenselectmodalComponent,
    CommmodalComponent,
    CrreceiptComponent,
    AddmodalComponent,
    AlladdComponent,
    RepbusinessreportComponent,
    TworeceiptComponent,
    PrintchallanComponent,
    OlddataupdateComponent,
    // ReportInDetailComponent,
    ExpenseledgerComponent,
    RepledgerComponent,
    CreditorsreportComponent,
    StampreceiptComponent,
    UpdatejournalvoucherComponent,
    SubscriberdetailsbriefComponent,
    StatewisestatementComponent,
    ActiveinactivebusinessreportComponent,
    StatewisebusinessreportComponent,
    CountrywisebusinessreportComponent,
    DistrictwisebusinessComponent,
    PrantwisebusinessComponent,
    TypewisebusinessreportComponent,
    AlladdlistComponent,
    JournaledgerlvoucherComponent,
    ThreeStampReceiptComponent,
    SecurityComponent,
    SubexpcvdvreportComponent,
    AddIssueSellerPerPriceComponent,
    BooktworeciptComponent,
    GranthOutstandingReportComponent,
    GranthOutstandingBriefComponent,
    OfficeRepBrieflyGranthComponent,
    UnpaidGranthOutstandingDetailComponent,
    UnpaidGranthOutstandingBriefComponent,
    OfficeRepUnpaidBrieflyGranthComponent,
    DistrictRepresentativeBussinessComponent,
    TrialBalanceComponent,
    TrialBalanceNewComponent,
    ExpenditureIncomeReportComponent,
    IssueSellerRegistrationReportComponentComponent,
    BookSellerLedgerBriefReportComponentComponent,
    IssueSellerCreditNoteRegisterInDetailComponent,
    IssueSellerCreditNoteVeryBrieflyCreditNoteComponent,
    IssueSellerCreditNoteBrieflyComponent,
    IssueSellerCreditNoteMonthwiseComponent,
    IssueSellerCreditNoteInDetailOfficerComponent,
    IssueSellerBrieflyOfficeCreditComponent,
    IssueSellerInvoiceBillComponent,
    ViewIssueSellerInvoiceComponent,
    ShowBookOrderComponent,
    PostingLabelBriefComponent,
    AddIssueSellerPerPriceComponent,
    IssueSellerInvoicePaymentReceiptComponent,
    AddBookCreditPriceComponent,
    AddBookPerPriceComponent1Component,
    Bookstoresendmessage1Component,
    AddBookCreditPrice1Component,
    PrasiddhiPatrakAddressComponent,
    BookCreditNoteRegisterComponent,
    AddModalListComponent,
    IssueContractReportComponent,
    AdvertisementAddressComponent,
    PrasiddhiPatrakListComponent,
    IssueCotractBriefReportComponent,
    AdvertisementAddressComponent,
    IssueSellerInvoiceRegisterComponent,
    IssueCreditVoucherPaymtRecieptBriflyReportComponent,
    IssueCreditVoucheofficerIndetailReportComponent,
    IssueCreditVoucherVeryBriflyOfficerReportComponent,
    IssuecreditvoucherbrieflyofficerreportComponent,
    IssueSellerIndetailCreditVoucherReportComponent,
    AddBookPerCommisionPriceComponent,
    BookCommRcptComponent,
    BookCommissionNoteRegisterComponent,
    BarcodeDialogComponent,
    CreaditReceiptComponentComponent,
    DepositSlipReportComponent,
    BookSellerPostingLabelBriefComponent,
    BooksellerwithpratiComponent,
    BooksellerwithoutpratiComponent,
    // BookSellerAddressLabelsComponent,
    AddressLableMobileNoEnglishComponent,
    BookSellerLedgerBriefReportComponentComponent,
    
    BooksellerdispatchreportlistComponent,
    BookSellerpostingOfficerepreportComponentComponent,
    NumberWithoutCommasPipeComponent,
    AdvertisementAddressListComponent,
    OutstandingReportComponent,
    IssueSellerPersonalLedgerComponent,
    IssueSellerBrieflyPersonalLedgerComponentComponent,
    IssueSellerAddressGSTReportComponent,
    IssueSellerOutstandibgIndetailReportsComponent,
    SaveAssignRepresentativeDistributerDailogComponent,
    AdvtOutstandingReportComponent,
    DistrictwiseOfficeRepresentativeBussinessComponent,
    IssueSellerAddressComponent,
    DebitVoucherBillComponent,
    PaymentReceiptRegisterComponent,
    PaymentRegisterMonthwiseComponent,
    PaymnetReceiptIndetailOfficerComponent,
    PaymnetReceieptVeryBreiflyOfficerComponent,
    PaymentReceiptBrieflyOfficerComponent,
    CreditNoteRegisterIndetailComponent,
    CreditNoteBrieflyRegisterComponent,

    //start
    IssueSellerHanddeliverylabelslistComponent,
    IssueSellerOtherStatePincodewiseStatementComponent,
    IssueSellerPincodewiseStatementComponent,
    IssueSellerHandDeliveryComponentComponent,
    IssueSellerPostStatementComponentComponent,
    IssueSellerStatewisestatementComponent,
    IssueSellerDistrictwiseStatementComponentComponent,
    IssueSellerPrantwiseVarganidarReportComponent,
    IssueSellerViewPrintOrderComponentComponent,
    IssueSellerPrintOrderStatementComponentComponent,
    IssueSellerLabelsOfHandDeliveryComponent,
    IssueSellerBarcodeDialogComponent,
    IssueSellerPostingLabelBriefComponent,
    IssueSellerPostingLabelBriefComponentComponent,
    IssueSellerAddressLabelsMobileNoComponent,
    IssueSellerAddressLabelsComponent,
    IssueSellerDistrictwiseVarganidarSubscriptionReportComponent,
    IssueSellerDistrictwiseSubscriptionReportComponent,
    IssueSellerPrintJavakComponentComponent,
    IssueSellerUpdatePrintOrderComponentComponent,
    //end


    CreditNoteMonthwiseRegisterComponent,
    SendReminderLetterBookComponent,
    SendReminderLetterRepBookComponent,
    CreditNoteInDetailCreditOfficerComponent,
    CreditNoteVeryBrieflyCreditNoteComponent,
    CreditNoteBrieflyOfficerCreditComponent,
    RepresentativeAddressListComponent,
    AdvtRepresentativeAddressListComponent,
    PaymentReceiptIndetailReportComponent,
    GSTReportComponent,
    BookReceiptReportComponent,
    DistrictandtalukawiseRepresentativeComponent,
    DistrictandtalukawiseOfficeRepresentativeComponent,
    RecoBriefReportComponent,
    BankRecoInBriefReportComponent,
    AccSubscriptionMonthwiseReportComponent,
    DatewiseBrieflyComponent,
    PrintOrderByfurgationReportComponent,
    PrintOrderByfurgationNewComponent,
    OfficeRepresentativeDistrictComponent,
    RepresentativewiseDistrictlyComponent,
    OfficeRepresentativeDistrictComponent,
    OfficeRepresentativeDistrictWiseComponent,
    TwoReceiptIssuesaleComponentComponent,
    AddAdvtRepPerPriceComponent,
    RegistrationRepVeryBrieflyComponent,
    UnpaidOutstandingInDetailComponent,
    RegistrationBrieflyRepresentativeComponent,
    AdvtInvoiceIndetailReportComponent,
    OutstandingBrieflyReportComponent,
    // BooksellerAddressLabelsMobileNoComponent,
    BookSellerAddressLabelsComponent,
    BookSellerdispatchLabelsComponent,
    BookSellerpracelLabelsComponent,
    BooksellerDistrictwiseStatementComponentComponent,
    BookSellerStatewisestatementComponent,
    // BookSellerpostingOfficerepreportComponentComponent
    BookReceiptVeryBrieflyOfficerComponent,
    BookReceiptIndetailOfficerComponent,
    OutstandingBrieflyReportComponent,
    RegistrationBrieflyRepresentativeComponent,
    RegistrationOfficeRepresentativeDetailComponent,
    RegistrationOfficeRepresentativeBrieflyComponent,
    RegistrationOfficeRepresentativeVbrieflyComponent,
    RegistrationDatewiseDetailsComponent,
    RegistrationDatewiseBrieflyComponent,
    RegistrationRepresentiveDetailComponent,
    RegistrationDatewiseVbrieflyComponent,
    UnpaidOutstandingBrieflyReportComponent,
    BookCreditNoteReportComponent,
    BookCreditNoteReportBrieflyComponent,
    BookRegistrationLedgerReportComponent,
    BookRegistrationLedgerReportBrieflyComponent,
    BookRegistrationLedgerReportVBrieflyComponent,
    BookRegistrationLedgerReportInDetailOfficerComponent,
    BookRegistrationLedgerReportVeryBrieflyOfficerComponent,
    BookRegistrationLedgerReportBrieflyOfficerComponent,
    BookCreditNoteReportMonthwiseComponent,
    BookCreditNoteReportInDetailOfficerComponent,
    BookCreditNoteReportVeryBrieflyOfficerComponent,
    OfficeRepInDetailsComponent,
    BookCreditNoteReportBrieflyOfficerComponent,
    AllRepBookCommissionComponent,
    RepCommissionPaidComponent,
    RepUnpaidCommissionComponent,
    BookReceiptReportComponent,
    BookReceiptIndetailOfficerComponent,
    OfficeRepBrieflyComponent,
    BookReceiptVeryBrieflyOfficerComponent,
    BookReceiptBrieflyOfficerComponent,
    BookReceiptMonthwiseComponent,
    BookReceiptIndetailallComponent,
    BookReceiptAllBrieflyComponent,
    OfficeRepInDetailsComponent,

    RegistrationBrieflyRepresentativeComponent,
    RegistrationRepresentiveDetailComponent,
    RegistrationDatewiseVbrieflyComponent,
    RegistrationIndetailsComponent,
    RegistrationBrieflyComponent,
    RegistrationOfficeRepresentativeVbrieflyComponent,
    OutstandingGstRegistrationReportComponent,
    IssueSellerCreditNoteRegisterComponentComponent,
    PersonalLedgerInDetailComponent,
    YearwiseAppComponent,
    PersonalLedgerInDetailComponent,
    PersonalLedgerInDetail1Component,
    IssueSalePrintChallanComponent,
    IssuesellerdispatchreportlistComponent,
    IssueSellerpostingOfficerepreportComponent,
    ComModalPrintComponent,
    ExpenseLedgerReportComponent,
    ComModalPrintComponent,
    CompletedCommissionReportComponent,
    PendingCommReportComponent,
    BriefAddressLabelComponent,
    PermissionsComponent,
    UserPermissionsComponent,
    UserManagementComponent,
    AdvtInvoiceMonthwiseRegisterComponent,
    RepresentativewiseTalukaComponent,
    AdvtInvoiceRegisterIndetailOfficerComponent,
    SubscriberRecLedgerAddressLabelComponent,
    PackageReportComponent,
    AdvtInvoiceRegisterOfficeBrieflyComponent,
    AdvtInvoiceRegisterOfficeVBrieflyComponent,
    ShowOrderEntryBookSellerComponent,

    OpeninvoiceprintComponent,
    AdvtoutstandingAllbrieflyComponent,
    UnpaidOutstandingVbrieflyComponent,
    AdvtInvoiceVeryBrieflyComponent,
    BooksellerbillingregisterreportComponent,
    AdvtStampRegisterReportComponentComponent,
    AdvtCreditPrintComponent,
    PrasiddhiPatrakRepresentaiveListComponent,
    CreditOutstandingIndetailsComponent,
    SendReminderLetterAdvtComponent,
    AllCommReportComponent,
    SendReminderLetterRepComponent,
    AddressAdvtLabelsComponent,
    TalukawiseSubscriberDetailsReportComponent,
    SubscriberListComponent,
    BusinessReportIndetailComponent,
    BusinessReportBrieflyComponent,
    BusinessReportVeryBrieflyComponent,
    IssueWiseReportAdvtBusinessComponent,
    BalanceSheetComponent,
    IssueWiseReportAdvtBusinessComponent,
    IssueWiseReportAdvtDetailBusinessComponent,
    CreditVoucherIssuesComponent,
    DebitVoucherIssuesComponent,
    RepresentativewiseSadhyasthitiReportComponent,
    DistrictRepresentativewiseSadhyasthitiReportComponent,
    TalukaRepresentativewiseSadhyasthitiReportComponent,
    ContractIndetailReportComponent,
    LekhakMasterComponent,
    AdvtissueYearWiseReportComponent,
    JahiriatJamaReportComponent,
    JahiratPratinidiwiseJamareportComponent,
    LekhReportComponent,
    YeneBakiJahiratReportComponent,
    YenebakiOffwiseJahirataComponent,
    ContractBrieflyReportComponent,
    CreditorsIssuesComponent,
    VatnavalDistributionComponent,
    ViewVatnavalComponent,
    ReceiptpackagebookComponent,
    ViewReceiptpackagebookComponent,
    SubscriptionTypeDistrictwiseComponent,
    GranthInvoiceComponent,
    ShowGranthInvoiceComponent,
    AllBusinessReportSubscriptionComponent,
    AllTotalBusinessReportSubscriptionComponent,
    PrantwiseAllTotalBusinessReportComponent,
    PrantwiseAllTotalTalukawiseBusinessReportComponent,
    MonthWiseBusinessReportComponent,
    ExpenseOpeningBalanceReportComponent,
    BarcodeDialogParcelLabelComponent,
    ParcelLabelBarcodesEnglishComponent,
    GranthRegistaionLedgerIndetailReportComponent,
    GranthRegistrationLedgerReportBriflyComponent,
    GranthRegistrationLedgerBriflyReportComponent,
    GranthRegistrationLedgerIndetailOfficerReportComponent,
    GranthRegistrationLedgerVeryBriflyOfficerReportComponent,
    GranthRegistrationLedgerBrieflyOfficerComponent,
    BusinessReportIndetailGranthComponent,
    VoucherListComponent,
    BussinessReportBriflyGranthComponent,
    AddressListAdvtComponentComponent,
    SendReminderLetterIssueComponent,
    SendReminderLetterIssueRepComponent,
    RegistrationReportGranthVeryBrieflyComponent,
    GranthBussinessOfficeRepIndetailsComponent,
    GranthBussinessOfficeRepIndetailsofficerepwiseComponent,
    GranthSellerLedgerBriefReportIndetailComponent,
    GranthSellerAddressLabelsComponent,
    GrantSellerWithoutPratiComponent,
    BookSellerPrintOrderStatementgranthComponent,
     GranthSellerDispatchLabelsComponent,
     GranthSellerHandDeliveryComponent,
     SaveAssignRepresentativeDistributerDailogComponentgranthComponent,
    GranthSellerWithPratiComponent,
    GranthSellerAddresscomponentgranthwithComponent,
    GranthSellerDispatchReportListComponent,
    GranthSellerPostingOffReportComponent,
    SendReminderLetterGranthComponent
  ],
  providers: [
    MatNativeDateModule,
    MatDatepickerModule,
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule { }
